const RICOS_VERSION = "10.141.4";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
